import { oneOf } from "prop-types";

export const brandCodePropType = oneOf([
	"gn",
	"gp",
	"sg",
	"om",
	"la",
	"pm",
	"fe",
	"ep",
	"nq",
	"ms",
	"sfg",
]).isRequired;
